import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { batch, useDispatch, useSelector } from "react-redux";
import { getbranchData } from "../../../redux/authentication";
import axios from "axios";
import {
  getInventoryItems,
  getInventoryPurchase,
  getInventorySupplier,
} from "../../../redux/inventory";
import { useNavigate } from "react-router-dom";

const InventoryForm = ({
  editFormData,
  formDataPurchase,
  setInventoryFormData,
  rowIndex,
  toggle,
}) => {
  const navigate = useNavigate();
  const itemsList = useSelector((state) => state.inventory);
  const auth = useSelector((state) => state.authentication);
  const dispatch = useDispatch();
  const { userData } = auth;
  const { supplierData, purchaseData, itemsData } = itemsList;

  const [formData, setFormData] = useState({
    ...formDataPurchase,
  });

  const [matchBatchExpiry, setMatchBatchExpiry] = useState("");

  function getItemByBatchAndExpiry(enteredBatch, enteredExpiryDate) {
    if (enteredBatch && enteredExpiryDate) {
      const enteredBatchLowercase = enteredBatch?.toLowerCase();

      if (Array.isArray(itemsData)) {
        for (const item of itemsData) {
          const itemBatchLowercase = item?.batch?.toLowerCase();
          if (
            itemBatchLowercase === enteredBatchLowercase &&
            enteredExpiryDate === item.expiry
          ) {
            setFormData({ ...formData, expiry: item.expiry });
            return item;
          }
        }
      }
    }
  }

  function isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  const validateForm = () => {
    if (!formData.batch) return false;

    if (matchBatchExpiry) {
      if (
        matchBatchExpiry.batch.toLowerCase() !== formData.batch.toLowerCase() ||
        matchBatchExpiry.expiry !== formData.expiry
      ) {
        alert("Please enter New Batch for New Date");
        return false;
      }
      return true;
    }

    if (!isValidDate(formData.expiry)) return false;

    return true;
  };

  const clearForm = () => {
    setFormData({
      item: "",
      brandName: "",
      unitPrice: "",
      tax: "",
      mrp: "",
      batch: "",
      expiry: "",
      hsn: "",
      manufacturer: "",
      quantity: "",
      location: "",
      category: "",
      minStockLevel: "",
      maxStockLevel: "",
      reorderPoint: "",
      reorderQuantity: "",
      supplierId: "",
      barcode: "",
      notes: "",
      consumable: false,
    });
  };

  useEffect(() => {
    if (editFormData && editFormData.invoice_id) {
      setFormData(() => {
        let expiryDate;
        if (!editFormData.expiry) {
          let inputDate = new Date();
          if (isNaN(inputDate)) inputDate = new Date();
          inputDate.setDate(inputDate.getDate() + 30);
          expiryDate = inputDate.toISOString().split("T")[0];
        }
        return {
          ...editFormData,
          expiry: editFormData.expiry || expiryDate,
        };
      });

      dispatch(
        getInventoryPurchase({
          token: userData.token,
          branch: userData.branch,
          invoice_id: editFormData.invoice_id,
        })
      );
    } else {
      setFormData((prevFormData) => {
        let expiryDate;
        if (!prevFormData.expiry) {
          let inputDate = new Date();
          if (isNaN(inputDate)) inputDate = new Date();
          inputDate.setDate(inputDate.getDate() + 30);
          expiryDate = inputDate.toISOString().split("T")[0];
        }
        return {
          ...prevFormData,
          expiry: prevFormData.expiry || expiryDate,
        };
      });
    }
  }, [editFormData]);

  useEffect(() => {
    if (formData?.batch && formData?.expiry) {
      setMatchBatchExpiry(() =>
        getItemByBatchAndExpiry(formData.batch, formData.expiry)
      );
    }
    if (formData?.batch && formData?.productId) {
      setMatchBatchExpiry(
        getItemByBatchAndExpiry(formData.batch, formData.expiry)
      );
    }
  }, [formData.batch, formData.expiry]);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    if (type === "date") {
      if (matchBatchExpiry) {
        alert("Please enter New Batch for New Date");
        return;
      }
    }
    setFormData((prevFormData) => {
      let expiryDate;
      if (!prevFormData.expiry) {
        let inputDate = new Date();
        if (isNaN(inputDate)) inputDate = new Date();
        inputDate.setDate(inputDate.getDate() + 30);
        expiryDate = inputDate.toISOString().split("T")[0];
      }

      return {
        ...prevFormData,
        expiry: prevFormData.expiry || expiryDate,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };

  useEffect(() => {
    if (userData.token) {
      dispatch(
        getbranchData({ token: userData.token, branch: userData.branch })
      );
      dispatch(
        getInventorySupplier({ token: userData.token, branch: userData.branch })
      );
    }
  }, [userData.token]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm() && editFormData) {
      editSubmitHandler();
      return;
    }

    if (validateForm()) {
      if (formDataPurchase.batch) {
        if (
          matchBatchExpiry &&
          matchBatchExpiry.batch.toLowerCase() ===
            formData.batch.toLowerCase() &&
          matchBatchExpiry.expiry === formData.expiry
        ) {
          alert("Continue & Save Purchase - match ");
          toggle();
          setInventoryFormData({
            ...formData,
            productId: matchBatchExpiry.productId,
            stockQty: matchBatchExpiry.quantity,
          });
          return;
        } else {
          alert("Continue & Save Purchase with New Batch");
          toggle();
          setInventoryFormData({
            ...formData,
          });
          return;
        }
      } else {
        alert("Continue & Save Purchase");
        toggle();
        setInventoryFormData({
          ...formData,
        });
      }
    } else {
      alert("Invalid Form");
      return;
    }
  };

  const editPurchaseHandler = () => {
    if (formDataPurchase.purchaseId) {
      const postPurchaseData = {
        ...formDataPurchase,
        paymentDetails: {
          ...formDataPurchase.paymentDetails,
          quantity: formData.quantity,
        },
      };

      axios
        .post(
          `${process.env.REACT_APP_COLLEGE_ERP_API}edit-purchase`,
          postPurchaseData,
          {
            params: {
              branch: userData.branch,
              purchaseId: formDataPurchase.purchaseId,
            },
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            dispatch(
              getInventoryItems({
                token: userData.token,
                branch: userData.branch,
              })
            );
            alert("Edit success");
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const editSubmitHandler = () => {
    axios
      .post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}edit-inventory`,
        formData,
        {
          params: {
            branch: userData.branch,
            productId: formData.productId,
          },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          dispatch(
            getInventoryItems({
              token: userData.token,
              branch: userData.branch,
            })
          );
          alert("Edit success");
          editPurchaseHandler();
          clearForm();
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Container fluid className="mt-3">
      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <Form.Group controlId="batch">
                  <Form.Label>Batch</Form.Label>
                  <Form.Control
                    type="text"
                    name="batch"
                    value={formData.batch}
                    onChange={handleChange}
                    placeholder="Enter batch"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="expiry">
                  <Form.Label>Expiry</Form.Label>
                  <Form.Control
                    type="date"
                    name="expiry"
                    value={formData.expiry}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="category">
                  <Form.Label>Category</Form.Label>
                  <Form.Control
                    as="select"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                  >
                    {formData.category ? null : (
                      <option value="">Select option</option>
                    )}
                    <option value="Grocery / Provisions">
                      Grocery / Provisions
                    </option>
                    <option value="Meat, Fish & Eggs">
                      Meat, Fish & Eggs
                    </option>
                    <option value="Vegetables & Fruits">
                      Vegetables & Fruits
                    </option>
                    <option value="Masalas">Masalas</option>
                    <option value="Dairy & Bakery">Dairy & Bakery</option>
                    <option value="Housekeeping & Consumables">
                      Housekeeping & Consumables
                    </option>
                    <option value="Beverages">Beverages</option>
                    <option value="Health & Wellness">
                      Health & Wellness
                    </option>
                    <option value="Miscellaneous">Miscellaneous</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="brandName">
                  <Form.Label>Brandname</Form.Label>
                  <Form.Control
                    type="text"
                    name="brandName"
                    value={formData.brandName}
                    onChange={handleChange}
                    placeholder="Enter brand name"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="manufacturer">
                  <Form.Label>Manufacturer</Form.Label>
                  <Form.Control
                    type="text"
                    name="manufacturer"
                    value={formData.manufacturer}
                    onChange={handleChange}
                    placeholder="Enter manufacturer"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Form.Group controlId="minStockLevel">
                  <Form.Label>Minimum Stock Level</Form.Label>
                  <Form.Control
                    type="text"
                    name="minStockLevel"
                    value={formData.minStockLevel}
                    onChange={handleChange}
                    placeholder="Enter minimum stock level"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="maxStockLevel">
                  <Form.Label>Maximum Stock Level</Form.Label>
                  <Form.Control
                    type="text"
                    name="maxStockLevel"
                    value={formData.maxStockLevel}
                    onChange={handleChange}
                    placeholder="Enter maximum stock level"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="reorderPoint">
                  <Form.Label>Reorder Point</Form.Label>
                  <Form.Control
                    type="text"
                    name="reorderPoint"
                    value={formData.reorderPoint}
                    onChange={handleChange}
                    placeholder="Enter reorder point"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="reorderQuantity">
                  <Form.Label>Reorder Quantity</Form.Label>
                  <Form.Control
                    type="text"
                    name="reorderQuantity"
                    value={formData.reorderQuantity}
                    onChange={handleChange}
                    placeholder="Enter reorder quantity"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={5}>
                <Form.Group controlId="barcode">
                  <Form.Label>Barcode</Form.Label>
                  <Form.Control
                    type="text"
                    name="barcode"
                    value={formData.barcode}
                    onChange={handleChange}
                    placeholder="Enter barcode no."
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={3}>
                <Form.Group controlId="location">
                  <Form.Label>Location</Form.Label>
                  <Form.Control
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group controlId="notes">
                  <Form.Label>Notes</Form.Label>
                  <Form.Control
                    type="text"
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    placeholder="Enter notes"
                  />
                </Form.Group>
              </Col>
              <Col md={2} className="mt-2">
                <Form.Group controlId="consumable">
                  <Form.Check
                    type="checkbox"
                    name="consumable"
                    label="Consumable"
                    checked={formData.consumable}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end mt-3">
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default InventoryForm;
